import React from "react";
import { createElementClass } from "../helpers";
export var Link = function Link(_a) {
  var href = _a.href,
      children = _a.children;

  if (!href) {
    return React.createElement(React.Fragment, null, children);
  }

  return React.createElement("a", {
    className: createElementClass("link"),
    href: href,
    target: href.startsWith("http") ? "_blank" : ""
  }, children);
};